import { render, staticRenderFns } from "./goodsManage.vue?vue&type=template&id=36f55e84&scoped=true"
import script from "./goodsManage.vue?vue&type=script&lang=js"
export * from "./goodsManage.vue?vue&type=script&lang=js"
import style0 from "./goodsManage.vue?vue&type=style&index=0&id=36f55e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f55e84",
  null
  
)

export default component.exports